import React from 'react';
import LazyLoad from 'react-lazyload';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="footer padded-sec">
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='title'>
                <p>contact us</p>
                <h2>get in touch</h2>
              </div>
            </div>
            <div className='col-md-12'>
              <div className="footer-flex">
                <div className='contact_details'>
                  <div>
                    <i className="bi bi-telephone-fill"></i>
                    <div><a href="tel:98152-13457">98152-13457</a>
                    </div>
                  </div>
                  <div>
                    <i className="bi bi-envelope-fill"></i>
                    <div><a href="mailto:stfrancisasr@gmail.com">stfrancisasr@gmail.com</a>
                    </div>
                  </div>
                  <div>
                    <i className="bi bi-geo-alt-fill"></i>
                    <div>31, Cantonment, Railway Estate Colony, Canal Colony, Amritsar, Punjab 143001</div>
                  </div>
                </div>
                <div><iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d27175.273585001425!2d74.83328799600474!3d31.63633644627637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s31%2C%20Cantonment%2C%20Railway%20Estate%20Colony%2C%20Canal%20Colony%2C%20Amritsar%2C%20Punjab%20143001!5e0!3m2!1sen!2sin!4v1739439837248!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
              </div>
            </div>
            <div className='col-md-12'>
              <div className='ftr-logo'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/logo.png" alt="St francis school, Amritsar" /></LazyLoad>
                <ul>
                  <li><a href="/" target="_blank">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/insta.png" alt="St francis school, Amritsar" /></LazyLoad>
                  </a></li>
                  <li><a href="https://www.facebook.com/profile.php?id=61556861055961&mibextid=ZbWKwL" target="_blank">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/facebook.png" alt="St francis school, Amritsar" /></LazyLoad>
                  </a></li>
                  <li><a href="/" target="_blank">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/youtube.png" alt="St francis school, Amritsar" /></LazyLoad>
                  </a></li>
                  <li><a href="/" target="_blank">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/linkdin.png" alt="St francis school, Amritsar" /></LazyLoad>
                  </a></li>

                </ul>
              </div>
            </div>

            {/*
            <div className='col-md-6'>
              <div className="mobile-app">
                <div>
                  <p><b>Download Mobile App </b>A Common Platform For <b>Educators, Parents & Teachers</b></p>
                  <div className='mobile-link'>
                    <img src="https://webapi.entab.info/api/image/MGMB/public/Images/app-store.png" />
                    <img src="https://webapi.entab.info/api/image/MGMB/public/Images/playstore.png" />
                  </div>
                  <p className='code'>Use School Code :</p>
                </div>
                <div>
                  <img src='https://webapi.entab.info/api/image/MGMB/public/Images/mobile.png' />
                </div>
              </div>
            </div> 
            */}

          </div>
        </div>
      </div>
      <div className='copyright'>
        ©️ Copyright 2017-{currentYear} St. Francis School, Amritsar. All Rights Reserved | Accelerating  by Entab Infotech : CampusCare
      </div>
    </>
  );
}

export default Footer;
